import CalendarWeek from '../models/calendar/CalendarWeek';
import CalendarDay from '../models/calendar/CalendarDay';
import CalendarMonth from '../models/calendar/CalendarMonth';

function _getMonthFromDate(date, allEvents) {
  let curr = new Date(date);
  curr.setDate(1);
  const startDate = new Date(curr);
  startDate.setHours(0);
  startDate.setMinutes(0);
  startDate.setSeconds(0);
  let firstMonday = _getMonday(curr);
  const last = _getNumberOfLastDayOfMonth(curr.getMonth());
  curr.setDate(last);
  const endDate = new Date(curr);
  endDate.setHours(23);
  endDate.setMinutes(59);
  endDate.setSeconds(59);
  const lastMondayOfMonth = _getMonday(curr);
  let weeks = [];
  curr = new Date(firstMonday);
  while (curr.getTime() <= lastMondayOfMonth.getTime()) {
    const week = _getWeekFromDate(curr, allEvents);
    for (let i = 0; i < week.days.length; i++) {
      const day = week.days[i];
      if (new Date(day.startDate).getMonth() !== startDate.getMonth()) {
        day.isCurrentMonth = false;
      }
      week.days[i] = day;
    }
    weeks.push(week);
    curr.setDate(curr.getDate() + 7);
  }
  const events = allEvents.filter(e => (e.dateStart >= startDate.getTime() && e.dateStart <= endDate.getTime()));
  // let events = [].concat.apply([], weeks.map(w => w.events));
  return new CalendarMonth(weeks, events, date);
}

function _getWeekFromDate(date, allEvents) {
  const curr = new Date(date);
  curr.setDate(curr.getDate() - (curr.getDay(curr)) + 1);
  const first = curr.getDate();
  // const first = curr.getDate() - curr.getDay(curr) + 1;
  const last = first + 6;
  let weekDays = [];
  let weekEvents = [];
  const lastOfMonth = _getNumberOfLastDayOfMonth(curr.getMonth());
  for (let i = first; i <= last; i++) {
    const dayNumber = i <= lastOfMonth ? i : i - lastOfMonth;
    const startDate = new Date(curr);
    startDate.setDate(i);
    startDate.setHours(0, 0, 0);
    const endDate = new Date(curr);
    endDate.setDate(i);
    endDate.setHours(23, 59, 59);
    const events = allEvents.filter(e => (e.dateStart >= startDate.getTime() && e.dateStart <= endDate.getTime()));
    const day = new CalendarDay(dayNumber, i - first, startDate.getTime(), endDate.getTime(), events);
    weekEvents = weekEvents.concat(events);
    weekDays.push(day);
  }
  const startDate = new Date(curr);
  startDate.setDate(first);
  startDate.setHours(0, 0, 0);
  const endDate = new Date(curr);
  endDate.setDate(last);
  endDate.setHours(23, 59, 59);
  return new CalendarWeek(startDate, endDate, weekDays, weekEvents);
}
function _getMonday(date) {
  const curr = new Date(date);
  const day = curr.getDay();
  const diff = curr.getDate() - day + (day === 0 ? -6 : 1);
  return new Date(curr.setDate(diff));
}

function _getNumberOfLastDayOfMonth(month) {
  let date = new Date();
  date.setMonth(month + 1);
  date.setDate(1);
  date.setHours(0, 0, 0);
  date.setSeconds(date.getSeconds() - 1);
  return date.getDate();
}

function _getMonthNameFromDate(date) {
  const objDate = new Date(date);
  objDate.setDate(1);
  const locale = 'it-it';
  const monthName = objDate.toLocaleString(locale, { month: 'long' });
  return monthName;
}

export default {
  getMonthFromDate: _getMonthFromDate,
  getWeekFromDate: _getWeekFromDate,
  getMonthNameFromDate: _getMonthNameFromDate
};
